module.exports = __webpack_public_path__ + "static/media/stir-fry.586a130a.png";